import React from 'react'
import { useState, useEffect } from 'react'
import styles from './apiForm.module.scss'
import Cookies from 'universal-cookie'

function ApiForm({
    fetchData,
    error,
    fetching,
}: {
    fetchData: (key: string) => Promise<void> | null
    error: boolean
    fetching: boolean
}) {
    const [key, setKey] = useState('')
    const cookies = new Cookies()
    const cookieKey = cookies.get('key')
    useEffect(() => {
        if (cookieKey) {
            setKey(cookieKey)
        }
    }, [cookieKey])

    return (
        <form className={styles.apiForm}>
            <label htmlFor="apiKey">API key: </label>
            <input
                aria-label="api-input"
                type="password"
                name="apiKey"
                id="apiKey"
                value={key}
                onChange={(e) => {
                    setKey(e.target.value)
                }}
                autoComplete="current-password"
            />
            <button
                type="submit"
                onClick={(e) => {
                    handleSubmit(e)
                }}
                disabled={fetching}
            >
                Submit
            </button>
            {fetching && <p aria-label="loading">...Loading</p>}
            {error && (
                <p aria-label="error" className={styles.formError}>
                    Unable to fetch data. Ensure that api key provided is
                    correct
                </p>
            )}
        </form>
    )

    function handleSubmit(e: React.FormEvent) {
        e.preventDefault()
        cookies.set('key', key, {
            //30 days
            maxAge: 60 * 60 * 24 * 30,
            sameSite: true,
        })
        fetchData(key)
    }
}

export default ApiForm
